import { i18n } from "../../i18n/i18n";

import React, { useState } from 'react';
import './popup.css';
import Button from '../../components/Button'
import InputText, { InputTextRef } from '../../components/InputText'
import PopupHeadingRow from '../../components/PopupHeadingRow'

interface PopupProps {
  isOpen: boolean;
  onSubmit: (username: string, password: string) => void;
}

const Popup: React.FC<PopupProps> = ({isOpen, onSubmit}) => {
  const [username, setUsernameValue] = useState('');
  const [password, setPasswordValue] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (name: string, value: string) => {
    if(name == 'managerPassword') {
      setPasswordValue(value);
    } else if(name == 'managerUsername') {
      setUsernameValue(value)
    }
  }

  const handleButtonClick = () => {
    onSubmit(username, password)
  }

  return (
    <div>
      {isOpen && (
        <div className="popup-overlay">
          <div className="popup" onClick={(e) => e.stopPropagation()}>    
          <label className="centered-label">Session blocked - UPC error</label>
          <br />
          <label className="centered-label-small">UPC does not match</label>
          <br /><br />
          <InputText
            name="managerUsername"
            value={username}
            label={i18n("Manager's username")}
            onChange={handleInputChange} />
            <InputText
            name="managerPassword"
            value={password}
            label={i18n("Manager's password")}
            type='password'
            onChange={handleInputChange} />

            <PopupHeadingRow
              heading=""
              doc='upc-error-block-warning'>
                <Button
                text={i18n("Submit")}
                onClick={handleButtonClick} />
            </PopupHeadingRow>

            {errorMessage && <div className="error-message">{errorMessage}</div>}
          </div>
        </div>
      )}
    </div>
  );
};

export default Popup;